import shouldForwardProp from '@styled-system/should-forward-prop'
import { isValidMotionProp, MotionConfig } from 'motion/react'

const isValidProp = prop => !isValidMotionProp(prop) && shouldForwardProp(prop)

export const MotionProvider = ({ children }) => (
  <MotionConfig isValidProp={isValidProp}>{children}</MotionConfig>
)
